module.exports = __webpack_public_path__ + "4923321b4e0e827344f53f0b30f9e0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bao-cao-tham-nhung.png
// module id = 2005
// module chunks = 0